import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
import moment from "moment";
import React from "react";
import { EmptyText } from "../../components/common/CellText";
import PeopleTag from "../../components/PeopleTag";
import { findCombiner, findHandler, findLeader } from "../../utils/common";

const InforDialog = ({
    isOpen,
    handleCloseInfo,
    descriptionElementRef,
    taskDetail,
}) => {
    return (
        <Dialog
            open={isOpen}
            onClose={handleCloseInfo}
            scroll={"paper"}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            className="doc-popup"
            fullWidth
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100vw",
                        maxWidth: "100vw", // Set your width here
                        mx: 0,
                    },
                },
            }}
        >
            <DialogTitle
                id="scroll-dialog-title"
                className="text-xl font-bold text-[#23374D] !py-9"
                sx={{
                    fontWeight: 700,
                }}
            >
                <span className="font-bold">Thông tin chung</span>
            </DialogTitle>
            <DialogContent>
                <DialogContentText
                    id="scroll-dialog-description"
                    ref={descriptionElementRef}
                    tabIndex={-1}
                    className=""
                >
                    <table
                        style={{ color: "#16192C" }}
                        className="doc-table-vertical font-semibold text-sm leading-5 text-[#16192C]"
                    >
                        <tr>
                            <th style={{ paddingBottom: 14 }}>
                                Hiển thị vào tháng:
                            </th>
                            <td
                                className="font-normal"
                                style={{ paddingBottom: 14 }}
                            >
                                {taskDetail?.display_date ? (
                                    "Tháng " +
                                    moment(taskDetail?.display_date).format(
                                        "MM/YYYY"
                                    )
                                ) : (
                                    <EmptyText>Không có</EmptyText>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th style={{ paddingBottom: 14 }}>
                                Loại nhiệm vụ:
                            </th>
                            <td
                                className="font-normal"
                                style={{ paddingBottom: 14 }}
                            >
                                {taskDetail?.tags?.length > 0 ? (
                                    taskDetail?.tags
                                        ?.map((tag) => tag.name)
                                        .join(", ")
                                ) : (
                                    <EmptyText>Không có</EmptyText>
                                )}
                            </td>
                        </tr>
                        <tr>
                            <th style={{ paddingBottom: 14 }}>Cấp giao:</th>
                            <td
                                className="font-normal"
                                style={{ paddingBottom: 14 }}
                            >
                                {taskDetail?.cap_giao ? (
                                    taskDetail.cap_giao.ten_cap_giao
                                ) : (
                                    <EmptyText>Không có</EmptyText>
                                )}
                            </td>
                        </tr>
                    </table>
                    <div className="font-semibold text-sm leading-5 text-[#16192C]">
                        <div style={{ paddingBottom: 14 }}>
                            <div>Lãnh đạo giao việc:</div>
                            <div className="flex flex-wrap mt-2 font-normal gap-x-2 gap-y-3">
                                {findLeader(taskDetail?.assignees)?.length >
                                0 ? (
                                    findLeader(taskDetail?.assignees)?.map(
                                        (item) => <PeopleTag el={item} />
                                    )
                                ) : (
                                    <EmptyText>Không có.</EmptyText>
                                )}
                            </div>
                        </div>
                        <div style={{ paddingBottom: 14 }}>
                            <div className="table-title">Xử lý chính:</div>
                            <div className="flex flex-wrap mt-2 font-normal gap-x-2 gap-y-3">
                                {findHandler(taskDetail?.assignees)?.length >
                                0 ? (
                                    findHandler(taskDetail?.assignees)?.map(
                                        (item) => <PeopleTag el={item} />
                                    )
                                ) : (
                                    <EmptyText>Không có.</EmptyText>
                                )}
                            </div>
                        </div>
                        <div style={{ paddingBottom: 14 }}>
                            <div className="table-title">Phối hợp xử lý:</div>
                            <div className="flex flex-wrap mt-2 font-normal gap-x-2 gap-y-3">
                                {findCombiner(taskDetail?.assignees)?.length >
                                0 ? (
                                    findCombiner(taskDetail?.assignees)?.map(
                                        (item) => <PeopleTag el={item} />
                                    )
                                ) : (
                                    <EmptyText>Không có.</EmptyText>
                                )}
                            </div>
                        </div>
                    </div>
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button
                    sx={{ fontWeight: 600 }}
                    onClick={handleCloseInfo}
                    className="pb-6 text-sm font-semibold leading-5 text-primary"
                >
                    Đóng
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default InforDialog;
